import { render, staticRenderFns } from "./DashboardActivities.vue?vue&type=template&id=cfcaecdc"
import script from "./DashboardActivities.vue?vue&type=script&lang=js"
export * from "./DashboardActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports